
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import {
  WalletProvider,
  ConnectionProvider,
} from "@solana/wallet-adapter-react";
import WalletConnectProvider from "./walletConnectProvider";
import { ToastContainer } from "react-toastify";
import "@solana/wallet-adapter-react-ui/styles.css";
import { config } from "./config"

const root = ReactDOM.createRoot(document.getElementById("root"));
// const endpoint = config.isMainnet ? config.mainNetRpcUrl : config.devNetRpcUrl;


root.render(
  // <ConnectionProvider endpoint={endpoint}>
  //   <WalletProvider wallets={[]} autoConnect>
  <WalletConnectProvider>
    <React.StrictMode>
      <App />
      <ToastContainer autoClose={3000} draggableDirection="x" />
    </React.StrictMode>
  </WalletConnectProvider>
  // </WalletProvider>
  // </ConnectionProvider>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
